export default __webpack_public_path__ + "static/forbes-ca15d8437dda9003668698efd8ffb848.svg";